/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventexamplepromptslabel3Inputs */

const en_eventexamplepromptslabel3 = /** @type {(inputs: Eventexamplepromptslabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need inspiration?`)
};

const de_eventexamplepromptslabel3 = /** @type {(inputs: Eventexamplepromptslabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brauchst du Inspiration?`)
};

/**
* | output |
* | --- |
* | "Need inspiration?" |
*
* @param {Eventexamplepromptslabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventexamplepromptslabel3 = /** @type {((inputs?: Eventexamplepromptslabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventexamplepromptslabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventexamplepromptslabel3(inputs)
	return de_eventexamplepromptslabel3(inputs)
});
export { eventexamplepromptslabel3 as "eventExamplePromptsLabel" }